
import Image from 'primevue/image';
import IftaLabel from 'primevue/iftalabel';
import Card from 'primevue/card';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { computed, onMounted, ref } from 'vue';

import { promotion } from '../apis/promotion';
import { AllPromotionResult } from '../types/promotion';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import Toast from 'primevue/toast';
import { main_wallet } from '../apis/main_wallet';

export default {
	name: 'PromotionList',
	components: {
		IftaLabel,
		Button,
		Card,
		Image,
		Dialog,
		Toast,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const {profile} = storeToRefs(auth);

		const toast = useToast();

		onMounted(() => {
			auth.hydrate();
			handlePromotionList();
		});

		const visible = ref(false);
		const listLoading = ref(false);
		const promotions = ref<AllPromotionResult[]>([]);
		const selectedPromotion = ref<AllPromotionResult>();
		const msgError = ref('');

		const promotionList = computed(() => promotions.value);

		const handlePromotionList = async () => {
			listLoading.value = true;
			try {
				const resp = await promotion.getAllPromotion();

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);
				promotions.value = resp.result as AllPromotionResult[];
			} catch (error) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				listLoading.value = false;
			}
		};

		const handleTakePromotion = async () => {
			try {
				const payload = {
					promotionId: selectedPromotion.value?.id,
				}

				const resp = await main_wallet.takePromotion(payload)

				if (resp.code !== '0') throw new Error(resp.message);

				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: '', life: 3000 });
			} catch (error) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {

			}
		}

		const clickBtnDialog = async (promo: AllPromotionResult) => {
			selectedPromotion.value = promo;
			msgError.value = '';
			try {
				const resp = await promotion.findPromotionByPlayer({
					id: promo.id,
					balanceAmount: profile.value?.balance || 0,
				});
				if (resp.code !== '0') throw new Error(resp.message);
			} catch (error: any) {
				msgError.value = error?.message || 'ไม่สามารถรับโปรโมชั่นนี้ได้';
			} finally {
				visible.value = true;
			}
		};

		const clickBtnDialogClose = () => {
			visible.value = false;
			selectedPromotion.value = undefined;
		};

		return {
			visible,
			listLoading,
			promotionList,
			selectedPromotion,
			msgError,
			handleTakePromotion,
			clickBtnDialog,
			clickBtnDialogClose,
		};
	},
};
